// extracted by mini-css-extract-plugin
export default {"transactions":"transactions__PhOuH","search":"search__nlqv_","error":"error__bfad4","content":"content__Q0LY0"};